export const FETCH_SERVER_INFO_REQUEST = 'serverInfo/FETCH_SERVER_INFO_REQUEST';
export const FETCH_SERVER_INFO_SUCCESS = 'serverInfo/FETCH_SERVER_INFO_SUCCESS';
export const FETCH_SERVER_INFO_FAILURE = 'serverInfo/FETCH_SERVER_INFO_FAILURE';
export const CLEAR_SERVER_INFO = 'serverInfo/CLEAR_SERVER_INFO';
